/* src/app/components/summarize/summarize-data-list/summarize-data-list.component.scss */
:host {
  display: block;
  width: 100%;
}
.summary-result {
  width: 100%;
  margin-bottom: 18px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 14px;
  box-shadow: 0 3px 14px rgba(15, 23, 42, 0.04);
  transition:
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.summary-result:hover {
  border-color: #d9dded;
  box-shadow: 0 7px 24px rgba(15, 23, 42, 0.07);
}
.summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 14px 18px;
  background: #fafbff;
  border-bottom: 1px solid #edf0f5;
}
.summary-title-wrapper {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}
.summary-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2ff;
  color: #5147d9;
  font-size: 15px;
}
.summary-title-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.summary-label {
  color: #273142;
  font-size: 13px;
  font-weight: 700;
}
.summary-subtitle {
  color: #98a1b1;
  font-size: 10px;
}
.summary-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  padding: 5px 9px;
  border-radius: 20px;
  background: #ecfdf3;
  border: 1px solid #d5f5e2;
  color: #15803d;
  font-size: 10px;
  font-weight: 600;
}
.summary-status i {
  font-size: 10px;
}
.summary-body {
  padding: 18px;
}
.summary-content {
  width: 100%;
  min-width: 0;
}
.content-heading {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 9px;
  color: #374151;
  font-size: 12px;
  font-weight: 700;
}
.heading-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #fff7ed;
  color: #ea580c;
  font-size: 11px;
}
.answer-content {
  width: 100%;
  color: #4b5563;
  font-size: 13px;
  line-height: 1.45;
  word-break: normal;
  overflow-wrap: anywhere;
}
.answer-content ::ng-deep p {
  margin: 0 0 5px;
  line-height: 1.45;
}
.answer-content ::ng-deep p:last-child {
  margin-bottom: 0;
}
.answer-content {
}
.answer-content ::ng-deep br {
  line-height: 1.2;
}
.answer-content {
}
.answer-content ::ng-deep strong,
.answer-content ::ng-deep b {
  color: #273142;
  font-weight: 700;
}
.answer-content {
}
.answer-content ::ng-deep ul,
.answer-content ::ng-deep ol {
  margin: 5px 0;
  padding-left: 21px;
}
.answer-content ::ng-deep li {
  margin: 0 0 2px;
  padding: 0;
  line-height: 1.4;
}
.answer-content ::ng-deep li:last-child {
  margin-bottom: 0;
}
.answer-content {
}
.answer-content ::ng-deep li > ul,
.answer-content ::ng-deep li > ol {
  margin-top: 3px;
  margin-bottom: 3px;
}
.answer-content {
}
.answer-content ::ng-deep h1,
.answer-content ::ng-deep h2,
.answer-content ::ng-deep h3,
.answer-content ::ng-deep h4,
.answer-content ::ng-deep h5,
.answer-content ::ng-deep h6 {
  margin-top: 9px;
  margin-bottom: 4px;
  color: #273142;
  font-weight: 700;
  line-height: 1.35;
}
.answer-content ::ng-deep h1 {
  font-size: 16px;
}
.answer-content ::ng-deep h2 {
  font-size: 15px;
}
.answer-content ::ng-deep h3 {
  font-size: 14px;
}
.answer-content ::ng-deep h4 {
  font-size: 13px;
}
.answer-content ::ng-deep h5,
.answer-content ::ng-deep h6 {
  font-size: 12px;
}
.answer-content {
}
.answer-content ::ng-deep > :first-child {
  margin-top: 0;
}
.answer-content {
}
.answer-content ::ng-deep blockquote {
  margin: 6px 0;
  padding: 7px 11px;
  border-left: 3px solid #6366f1;
  border-radius: 0 5px 5px 0;
  background: #f8f8ff;
  color: #596174;
}
.answer-content {
}
.answer-content ::ng-deep pre {
  max-width: 100%;
  margin: 6px 0;
  padding: 10px;
  overflow-x: auto;
  border: 1px solid #e5e9f2;
  border-radius: 6px;
  background: #f8fafc;
  line-height: 1.4;
}
.answer-content ::ng-deep code {
  font-size: 0.92em;
  overflow-wrap: anywhere;
}
.answer-content ::ng-deep pre code {
  overflow-wrap: normal;
}
.answer-content {
}
.answer-content ::ng-deep a {
  color: #5147d9;
  text-decoration: underline;
  overflow-wrap: anywhere;
}
.answer-content {
}
.answer-content ::ng-deep table {
  width: 100%;
  margin: 6px 0;
  border-collapse: collapse;
  font-size: 12px;
}
.answer-content ::ng-deep th,
.answer-content ::ng-deep td {
  padding: 6px 8px;
  border: 1px solid #e5e9f2;
  text-align: left;
  vertical-align: top;
}
.answer-content ::ng-deep th {
  background: #f8f9fc;
  color: #273142;
  font-weight: 700;
}
.answer-content {
}
.answer-content ::ng-deep hr {
  margin: 8px 0;
  border: 0;
  border-top: 1px solid #e5e9f2;
}
.answer-content {
}
.answer-content ::ng-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}
.summary-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 18px;
  background: #fafbfc;
  border-top: 1px solid #edf0f4;
}
.timestamp-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
}
.timestamp-icon {
  color: #9aa3b1;
  font-size: 11px;
}
.timestamp-text {
  color: #8b95a5;
  font-size: 10px;
}
.generated-label {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #9a91d9;
  font-size: 10px;
  font-weight: 500;
}
.generated-label i {
  font-size: 10px;
}
@media (max-width: 767px) {
  .summary-header {
    padding: 12px 14px;
  }
  .summary-body {
    padding: 14px;
  }
  .summary-footer {
    padding: 9px 14px;
  }
  .summary-subtitle {
    display: none;
  }
  .summary-status span {
    display: none;
  }
  .summary-status {
    width: 26px;
    height: 26px;
    justify-content: center;
    padding: 0;
  }
  .answer-content {
    font-size: 12px;
    line-height: 1.4;
  }
  .answer-content ::ng-deep p {
    margin-bottom: 4px;
    line-height: 1.4;
  }
  .answer-content ::ng-deep ul,
  .answer-content ::ng-deep ol {
    margin: 4px 0;
    padding-left: 18px;
  }
  .answer-content ::ng-deep li {
    margin-bottom: 2px;
    line-height: 1.35;
  }
  .answer-content ::ng-deep h1,
  .answer-content ::ng-deep h2,
  .answer-content ::ng-deep h3,
  .answer-content ::ng-deep h4,
  .answer-content ::ng-deep h5,
  .answer-content ::ng-deep h6 {
    margin-top: 7px;
    margin-bottom: 3px;
  }
  .answer-content ::ng-deep blockquote {
    margin: 5px 0;
    padding: 6px 9px;
  }
}
@media (max-width: 480px) {
  .summary-result {
    border-radius: 10px;
  }
  .summary-header {
    align-items: flex-start;
    gap: 8px;
    padding: 11px 12px;
  }
  .summary-title-wrapper {
    gap: 9px;
  }
  .summary-icon {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
    border-radius: 8px;
  }
  .summary-label {
    font-size: 12px;
  }
  .summary-body {
    padding: 12px;
  }
  .content-heading {
    margin-bottom: 7px;
  }
  .summary-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 7px;
    padding: 9px 12px;
  }
  .answer-content {
    font-size: 12px;
    line-height: 1.4;
  }
  .answer-content ::ng-deep table {
    display: block;
    overflow-x: auto;
    white-space: normal;
  }
}
/*# sourceMappingURL=summarize-data-list.component.css.map */
